module.exports = __webpack_public_path__ + "img/arrow2.b3b25a17.svg";